import api from "../services/apis";

/* ------------------------------------------------------------------------ *
 * CREATED: 01/06/22 - LAST UPDATE: 00/00/00                  FORMATA VALOR *
 * ------------------------------------------------------------------------ */
export function zzCheckNull( campo ) {
  return ( campo ) ? campo : '';
}

/* ------------------------------------------------------------------------ *
 * CREATED: 01/06/22 - LAST UPDATE: 00/00/00                  FORMATA VALOR *
 * ------------------------------------------------------------------------ */
export function zzFormat( valor ) {
  //return Number(valor).toFixed(2);
  //return ( valor ).formatMoney(2, ".", ",");
  return Number(valor).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

/* ------------------------------------------------------------------------ *
 * CREATED: 16/09/22 - LAST UPDATE: 00/00/00                          LOG() *
 * ------------------------------------------------------------------------ */
export function zzLog( texto, feature_id=0 ) {
  const tokenjwt = "339|9eIgAUyeTwQcbwalVm1XJlqMJnrAEQSn2Zlynxhx";
  const config   = {
    headers: { Authorization: `Bearer ${tokenjwt}` }
  };  
  const objTbl = {
    log        : texto      ,
    feature_id : feature_id ,
    token      : tokenjwt   ,
  };
  api.post( "/logs", objTbl, config );
}